import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AvailableAppsDetailsPage = React.lazy(() => import(/* webpackChunkName: "AvailableAppsDetails" */ './AvailableAppsDetails'));
export const AvailableAppsDetails = () => (React.createElement(Page, { title: "View available case details", description: "View available details of appearance according to area" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AvailableAppsDetailsPage, null)))));
